import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons'
import { Segmented } from 'antd'
import { FC, ReactNode } from 'react'
import { DesignerTasksScale } from '../../types/scale'

const SCALE_OPTIONS: { value: DesignerTasksScale; icon: ReactNode; title: string }[] = [
    { value: 'normal', icon: <ZoomOutOutlined />, title: 'Обычный размер' },
    { value: 'large', icon: <ZoomInOutlined />, title: 'Крупный размер' },
]

interface ScaleSwitchProps {
    value: DesignerTasksScale
    onChange: (value: DesignerTasksScale) => void
}

const ScaleSwitch: FC<ScaleSwitchProps> = ({ value, onChange }) => {
    return <Segmented options={SCALE_OPTIONS} value={value} onChange={onChange} />
}

export default ScaleSwitch
